<!-- ══════════════════════════════════════════════════════════════ -->
<!-- TAB BAR                                                        -->
<!-- ══════════════════════════════════════════════════════════════ -->
<nav class="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0a0a0a]/95 pb-safe-b backdrop-blur-md sm:hidden"
  aria-label="Primary">
  <ul class="flex h-14 items-stretch">
    @for (tab of tabs; track tab.path) {
      <li class="flex-1">
        <a [routerLink]="tab.path"
          class="relative flex h-full flex-col items-center justify-center gap-0.5 px-0.5 transition-[color,transform] duration-200 active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
          [class.text-indigo-400]="isActive(tab)"
          [class.text-gray-400]="!isActive(tab)"
          [attr.aria-current]="isActive(tab) ? 'page' : null">
          @if (isActive(tab)) {
            <span class="absolute inset-x-0 top-0 mx-auto h-0.5 w-8 rounded-full bg-indigo-400" aria-hidden="true"></span>
          }
          <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" aria-hidden="true">
            @switch (tab.icon) {
              @case ('home') {
                <path d="M15 21v-7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v7" />
                <path d="M3 10.2a2 2 0 0 1 .7-1.5l7-6a2 2 0 0 1 2.6 0l7 6a2 2 0 0 1 .7 1.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              }
              @case ('search') {
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
              }
              @case ('tv') {
                <rect x="2" y="7" width="20" height="15" rx="2" />
                <path d="m17 2-5 5-5-5" />
              }
              @case ('star') {
                <path d="M12 2.5l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3-5.8 3 1.1-6.5L2.6 9.3l6.5-.9z" />
              }
            }
          </svg>
          <span class="text-[10px] font-medium leading-none">{{ tab.label }}</span>
        </a>
      </li>
    }

    <!-- Music sits last: it is the newest tab, so it goes at the end of the row rather than
         between the long-standing ones. -->
    <li class="flex-1">
      <a [routerLink]="musicTab.path"
        class="relative flex h-full flex-col items-center justify-center gap-0.5 px-0.5 transition-[color,transform] duration-200 active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
        [class.text-indigo-400]="isActive(musicTab)"
        [class.text-gray-400]="!isActive(musicTab)"
        [attr.aria-current]="isActive(musicTab) ? 'page' : null">
        @if (isActive(musicTab)) {
          <span class="absolute inset-x-0 top-0 mx-auto h-0.5 w-8 rounded-full bg-indigo-400" aria-hidden="true"></span>
        }
        <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 18V5l12-2v13" />
          <circle cx="6" cy="18" r="3" />
          <circle cx="18" cy="16" r="3" />
        </svg>
        <span class="new-badge pointer-events-none absolute left-1/2 top-1 ml-0 rounded-full bg-red-500 px-1 py-px text-[8px] font-bold uppercase leading-none tracking-wide text-white">New</span>
        <span class="text-[10px] font-medium leading-none">{{ musicTab.label }}</span>
      </a>
    </li>
  </ul>
</nav>
